import React, { useState, useEffect, useLayoutEffect } from 'react';
import Header from '../Header/Header';
import { connect } from 'react-redux';
import * as Actions from '../../actions/actions';
import SkuUpdateTabAttribute from '../SkuUpdateTabAttribute/SkuUpdateTabAttribute';
import SkuUpdateTabMergePackageType from '../SkuUpdateTabMergePackageType/SkuUpdateTabMergePackageType';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Auth } from 'aws-amplify';
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import {SKU_ERROR_ANALYSIS} from "../../actions/actions";
import {getIssuTypes, getSkuErrorURL} from "../../services/API";
import {Constants} from "../DashBoard/Constants";
import * as EdgePCActions from "../../actions/edgepcs";


const SkuUpdate = (props) => {
    const [brands, setBrands] = useState(props.brands);
    const [packageType, setPackageType] = useState(props.packageType);
    const [selectedTab, setSelectedTab] = useState(0);
    const [indicatorOn, setIndicatorOn] = useState(false);
    const [skuErroreURL, setSkuErroreURL] = useState(null)
    const [windowWidth,setWindowWidth] = useState(1250)

    useLayoutEffect(() => {
        document.body.style.backgroundColor = "#fff"
        console.log("Sku Update")
    });

    useEffect(() => {
        Auth.currentSession().then(res => {
            let accessToken = res.getAccessToken();
            let jwt = accessToken.getJwtToken();
            localStorage.setItem('authToken', jwt);
            props.fetchVorCustomers();
            props.fetchCustomersWithDC()

            //getSKUErrorURL()
           // props.fetchSkuErrors();
           // setIndicatorOn(true);
        })
        Constants.DATA_LOADED = false;
    }, []);


    useEffect(() => {
        if (props.skuErrorURL) {
            setSkuErroreURL(props.skuErrorURL);
            setIndicatorOn(false);
        } else {
           // setSkuErroreURL(null);
            setIndicatorOn(false);
        }
        console.log(props.skuErrorURL)
    }, [props.skuErrorURL])


    let getSKUErrorURL = async ()=>{
        setIndicatorOn(true);
        setSkuErroreURL(null);
        let result = await getSkuErrorURL();
        console.log(result);
        if(result && result["embed-url"]){
            setSkuErroreURL(result["embed-url"]);
        }else{
            setSkuErroreURL(null);
        }
        setIndicatorOn(false);
    }
    useEffect(()=>{
        if(Constants.SIDE_MENU_OPEN){
            setWindowWidth(1250)
        }else{
            setWindowWidth(1250)
        }
    },[Constants.SIDE_MENU_OPEN]);
    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
        getSKUErrorURL();
        props.clearTabError();
    };

    const TabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        {children}
                    </Box>
                )}
            </div>
        );
    }

    let onErrorUpdate = ()=>{
        console.log("Error Update");
       // console.log(props);
       // props['error'] = "error";
    }
    return (
        <div style={{ width: '100%' }}>
            <div>
                <h3 style={{ textAlign: 'left' }}>SKU Update</h3>
                {props.error && <Alert severity="error" sx={{ marginBottom: '20px' }}>{props.error}</Alert>}
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={selectedTab} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="SKU attributes update" />
                            <Tab label="Merge Package Type" />
                            <Tab label="SKU Error Analysis" />
                        </Tabs>
                    </Box>
                    <TabPanel value={selectedTab} index={0}>
                        <Box sx={{ width: '100%' }}>
                             <SkuUpdateTabAttribute customersVorList={props.customers} selectedDC={props.customers}  onErrorUpdate={onErrorUpdate} onLoaded={Constants.DATA_LOADED}/>
                        </Box>
                    </TabPanel>
                    <TabPanel value={selectedTab} index={1}>
                        <SkuUpdateTabMergePackageType customersVorList={props.customersVorList}/>
                    </TabPanel>
                    <TabPanel value={selectedTab} index={2}>
                        <div style={{ width: ("100%") }}>
                            {indicatorOn ?
                                <div>
                                    <Backdrop
                                        sx={{ color: '#000', backgroundColor: 'rgb(255,255,255,0.7)', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                                        open={indicatorOn}
                                    >
                                        <p>Please wait, while data is loading...</p> <CircularProgress color="inherit" />
                                    </Backdrop>
                                </div> : ''
                            }
                            {skuErroreURL ?
                                <div style={{ width: '100%', height: '63vh' }}>
                                    <iframe
                                        width="100%"
                                        height="100%"
                                        src={skuErroreURL}
                                    ></iframe>
                                </div> : <p>No data available</p>}
                        </div>
                    </TabPanel>
                </Box>
            </div>
        </div>
    );
}
const mapStateToProps = (state) => {
    return {
        error: state.skuUpdate.error,
        customersVorList: state.skuUpdate.customersVorList,
        skuErrorURL: state.skuUpdate.skuErrorData,
        selectedDC: state.edgePCs.selectedDistributionCenter,
        customers: state.edgePCs.customers
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        clearTabError:()=>dispatch(Actions.LOAD_SKUSBY_REFRENCE_WITH_ERROR("")),
        fetchVorCustomers: () => dispatch(Actions.LOAD_VOR_CUSTOMERS()),
        fetchSkuErrors: () => dispatch(Actions.SKU_ERROR_ANALYSIS()),
        fetchCustomersWithDC: () => dispatch(EdgePCActions.LOAD_CUSTOMERS_WITH_DC()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SkuUpdate);
